import React from 'react';
import { graphql } from 'gatsby';
import { OmProductCarousel } from '@om/component-library-react';
import RefinedProductCard from '../components/RefinedProductCard';

function createSlotName(index) {
    return `card-${index + 1}`;
}

function number_of_cards(om_carousel_slot) {
    return om_carousel_slot ? om_carousel_slot.length : 0;
};

const ProductCarousel = ({
    productCarouselContent,
    slot
}) => {
    if (!productCarouselContent) {
        return '';
    }
    const {
        use_heading_as_h1,
        has_boundary,
        top_line,
        heading,
        sub_title,
        caption,
        om_carousel_slot,
        button_text,
        button_url,
        button_action_type,
        call_me_back,
        open_tab,
        is_extended_carousel
    } = productCarouselContent;

    return (
        <OmProductCarousel
            slot={slot}
            hasBoundary={has_boundary}
            buttonText={button_text}
            buttonUrl={button_url? button_url.href : ''}
            buttonActionType={button_action_type}
            callMeBackObject={call_me_back ? JSON.stringify(call_me_back) : ''}
            openTab={open_tab}
            numberOfCards={number_of_cards(om_carousel_slot)}
            isExtended={is_extended_carousel}
        >
            {
                top_line ? <span slot="top-line" dangerouslySetInnerHTML={{__html: top_line}}/> : ''
            }
            {
                heading ?
                    (use_heading_as_h1 ?
                        <h1 slot="heading" dangerouslySetInnerHTML={{__html: heading}} />
                        :  <span  slot="heading" dangerouslySetInnerHTML={{__html: heading}} />)
                    : ''
            }
            {
                sub_title ? <span slot="sub-title" dangerouslySetInnerHTML={{__html: sub_title}} /> : ''
            }
            {
                caption ? <span slot="caption" dangerouslySetInnerHTML={{__html: caption}} /> : ''
            }
            {
                om_carousel_slot ? om_carousel_slot.map((card, index) => {
                    return (
                        <RefinedProductCard
                            key={card.uid}
                            refinedProductCardContent={card}
                            isLandscape={number_of_cards(om_carousel_slot) === 1}
                            isExtended={is_extended_carousel}
                            slot={createSlotName(index)}
                        />
                    );
                }) : ''
            }
        </OmProductCarousel>
    );
};

export const pageQuery = graphql`
fragment ProductCarousel on Contentstack_product_carousel {
    uid
    use_heading_as_h1
    has_boundary
    top_line
    heading
    sub_title
    caption
    om_carousel_slot {
        ...RefinedProductCard
    }
    button_text
    button_url {
        ...Link
    }
    button_action_type
    call_me_back {
        ...CallMeBack
    }
    open_tab
    is_extended_carousel
}
`;

export default ProductCarousel